import RegistryPhaseWorkspace, {
  type RegistryPhaseWorkspaceConfig,
} from '../../../components/registry/RegistryPhaseWorkspace';
import { DERMATO_PHASES, computePhaseStatuses, type DermatoPhase } from './phases';
import Faza1Page from './Faza1Page';
import Faza2Page from './Faza2Page';
import Faza3Page from './Faza3Page';
import Faza4Page from './Faza4Page';

const config: RegistryPhaseWorkspaceConfig = {
  program: 'DERMATO',
  routeSegment: 'dermato',
  phases: DERMATO_PHASES,
  computeStatuses: computePhaseStatuses,
  pages: { 1: Faza1Page, 2: Faza2Page, 3: Faza3Page, 4: Faza4Page },
  emptyTitle: 'Registru dermato',
  emptyDescription: 'Pacientul nu are încă date de registru dermato importate.',
};

/** Spațiul de lucru dermato (/patients/:id/dermato/faza-N): registrul importat, pe faze. */
export default function DermatoWorkspace({ phase }: { phase: DermatoPhase }) {
  return <RegistryPhaseWorkspace config={config} phase={phase} />;
}
